import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Lobby from "@/pages/Lobby";
import Game from "@/pages/Game";
import WalletPage from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Ranking from "@/pages/Ranking";
import Forum from "@/pages/Forum";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090B0E]">
      <div className="w-12 h-12 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth" element={<AuthCallback />} />
      <Route path="/lobby" element={<Protected><Lobby /></Protected>} />
      <Route path="/game" element={<Protected><Game /></Protected>} />
      <Route path="/carteira" element={<Protected><WalletPage /></Protected>} />
      <Route path="/perfil" element={<Protected><Profile /></Protected>} />
      <Route path="/ranking" element={<Protected><Ranking /></Protected>} />
      <Route path="/forum" element={<Protected><Forum /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" theme="dark" richColors />
          </BrowserRouter>
        </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
